import React, { useEffect, useState } from "react";
import { Modal, Button, ConfigProvider, Radio, Space } from "antd";
import { useNavigate } from "react-router-dom";
import { CheckCircleFilled } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { setReRenderMenu } from "../redux/features/main/localizationSlice";
import { setLocalStorage, getLocalStorage, lanSetting } from "../utils";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
// color config
import {
  textTitleHome,
  checkCircleIcon,
  ColorPrimary,
  colorTextTitleMobile,
} from "../config/constant/color/index";

const ModalChangeLanguage = ({
  ti18n,
  i18n,
  setIsOpenModalChangeLanguage,
  isOpenModalChangeLanguage,
  setMessageSnack,
  setOpenedSnack
}) => {
  const screens = useBreakpoint();
  const isScallingVersion =
  window.innerWidth < 992 && (window.innerHeight >= window.innerWidth || window.innerWidth > window.innerHeight);
  const isMobileVersion = screens.xs || isScallingVersion;
  const reRenderMenu = useSelector((state) => state.localization.reRenderMenu);
  const userId = useSelector((state) => state.localization.userId);
  const dispatch = useDispatch();
  const [currLanguage, setCurrLanguage] = useState("en");

  const radioSelected = (e) => {
    setCurrLanguage(e.target.value);
  };

  const changeLanguageClickOk = () => {
    setIsOpenModalChangeLanguage(!isOpenModalChangeLanguage);
    i18n.changeLanguage(currLanguage);
    dispatch(setReRenderMenu(!reRenderMenu));

    const setlanguage = {};
    setlanguage[lanSetting.user_id] = userId;
    setlanguage[lanSetting.lan] = currLanguage;

    let arrLocal = getLocalStorage(lanSetting.lan_set);
    let jsonGet =
      Array.isArray(arrLocal) === true ? arrLocal : JSON.parse(arrLocal);
    let isPushed = 0;

    if (jsonGet.length > 0) {
      for (var i = 0; i < jsonGet.length; i++) {
        if (jsonGet[i][lanSetting.user_id] === userId) {
          isPushed = 1;
        }
      }
    }

    if (isPushed === 1) {
      for (var i = 0; i < jsonGet.length; i++) {
        if (jsonGet[i][lanSetting.user_id] === userId) {
          jsonGet[i][lanSetting.lan] = currLanguage;
        }
      }
    } else {
      jsonGet.push(setlanguage);
    }

    setLocalStorage(lanSetting.lan_set, JSON.stringify(jsonGet));
    setMessageSnack(ti18n("feature.home.pop_up_change_language.snack_change_language"));
    setOpenedSnack(true);
  };

  // useEffect for default radio button active based on based Language saved
  useEffect(() => {
    const userIdLocal = getLocalStorage(lanSetting.user_id);
    const lanConst = getLocalStorage(lanSetting.lan_set);
    let jsonGet =
      Array.isArray(lanConst) === true ? lanConst : JSON.parse(lanConst);

    setCurrLanguage("en");

    for (var i = 0; i < jsonGet.length; i++) {
      if (jsonGet[i][lanSetting.user_id] === parseInt(userIdLocal)) {
        setCurrLanguage(jsonGet[i][lanSetting.lan]);
      }
    }
  }, [userId]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            borderRadiusLG: isMobileVersion ? "16px" : "24px",
          },
          Radio: {
            buttonCheckedBg: ColorPrimary,
            radioSize: 20,
            dotSize: 12,
            buttonColor: ColorPrimary,
            wrapperMarginInlineEnd: 24,
          },
        },
        token: {
          fontFamily: "Roboto",
        },
      }}
    >
      <Modal
        open={isOpenModalChangeLanguage}
        maskClosable="false"
        closeIcon={false}
        width={424}
        style={{ maxWidth: isMobileVersion ? "90%" : "424px" }}
        transitionName="ant-fade"
        centered
        footer={null}
      >
        <div
          style={{
            textAlign: "center",
            padding: isMobileVersion ? "20px" : "32px",
          }}
        >
          <p
            style={{
              color: isMobileVersion ? colorTextTitleMobile : textTitleHome,
              fontSize: isMobileVersion ? 16 : 22,
              fontWeight: 500,
            }}
          >
            {ti18n("feature.home.pop_up_change_language.change_language")}
          </p>
          <div
            className="radio-change-language"
            style={{ textAlign: "left", fontSize: 14 }}
          >
            <Radio.Group
              onChange={radioSelected}
              defaultValue={currLanguage}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Radio value="en" style={{ marginBottom: 16 }}>
                English
              </Radio>
              <Radio value="id">Bahasa Indonesia</Radio>
            </Radio.Group>
          </div>
          <Button
            className="btn btn-sm btn-primary btn-block"
            style={{
              borderRadius: "6px",
              border: "none",
              fontWeight: "500",
              marginTop: isMobileVersion ? "20px" : "30px",
              height: isMobileVersion ? "40px" : "48px",
            }}
            name="btn-ok-change-password"
            onClick={() => changeLanguageClickOk()}
          >
            {ti18n("feature.home.pop_up_change_language.ok_change_language")}
          </Button>
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default ModalChangeLanguage;
